/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

import { IBuyboxViewProps } from './citta-enquireonly-buybox';

const BuyboxView: React.FC<IBuyboxViewProps> = props => {
    const { 
        ModuleProps,
        MediaGalleryContainerProps,
        ProductInfoContainerProps,
        addToCart,
        description,
        title,
        productSpecs,
    } = props;

    return (
        <Module {...ModuleProps}>
            <Node {...MediaGalleryContainerProps}>
                {props.mediaGallery}
            </Node>
            <Node {...ProductInfoContainerProps}>
                <h1 className="ms-buybox__product-title">{title}</h1>
                {description && 
                <MsDyn365.RichTextComponent
                    text={description}
                    className='msc-order-summary__summary-text'
                />}
                {addToCart}
                {productSpecs}
            </Node>
        </Module>
    );
};

export default BuyboxView;
